<form [formGroup]="form" autocomplete="off" class="ids-my-7 ids-d-block">
  <ids-likert formControlName="assessment" [lang]="lang" role="group">
    {{ 'LIKERT.DO_YOU_LIKE' | translate }}
  </ids-likert>
</form>